import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  CustomInput,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Loading from "../../components/loading/Loading";
import { Constants } from "../../Constants";
import { toast, ToastContainer } from "react-toastify";
import { useHistory } from "react-router";
import { deleteMember, fetchMembers, imageUpload, postMember } from "../../services/MembersServices";

export default function FooterConfig() {
  const [image, setImage] = useState("");
  const [url, setUrl] = useState("");
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const history = useHistory();

  useEffect(() => {
    fetch();
  }, []);

  const handleFiles = async (event: any) => {
    for (let file of event.target.files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "integrator",
        });
        setImage(response.data.data.image);
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchMembers({
        token: "",
      });
      setMembers(response.data.data);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      let response = await postMember({
        token: "",
        image,
        url: url,
        title,
      });
      setLoading(false);
      setImage("");
      setUrl("");
      setTitle("");
      fetch();
      toast(`Integrante generado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const remove = async (id: number) => {
    setLoading(true);
    try {
      let response = await deleteMember({
        token: "",
        id,
      });
      setLoading(false);
      fetch();
      toast(`Integrante eliminado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <div className="page-content">
      <ToastContainer />
      {loading && <Loading />}
      <Container fluid>
        <Breadcrumbs title="Footer" breadcrumbItem="Listado de integrantes" />
        <FormGroup row>
          <Label className="col-md-2 col-form-label">Título</Label>
          <Col md={10}>
            <Input value={title} onChange={(e) => setTitle(e.target.value)} />
          </Col>
        </FormGroup>
        <FormGroup row className="mt-2">
          <Label className="col-md-2 col-form-label">URL</Label>
          <Col md={10}>
            <Input value={url} onChange={(e) => setUrl(e.target.value)} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label
            htmlFor="example-datetime-local-input"
            className="col-md-2 col-form-label"
          >
            Imagen
          </Label>
          <Col md={10}>
            <div className="custom-file">
              <CustomInput
                id="file"
                type="file"
                name="file"
                className="custom-file-input"
                onChange={handleFiles}
                style={{ marginTop: "0.5rem" }}
              />
            </div>
          </Col>
        </FormGroup>
        {image !== "" && (
          <FormGroup row style={{ marginBottom: "0.5rem" }}>
            <Col md={2} />
            <Col md={10}>
              <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                <div className="p-2">
                  <Row className="align-items-center">
                    <Col className="col-auto">
                      <img
                        data-dz-thumbnail=""
                        height="80"
                        className="avatar-sm rounded bg-light"
                        style={{ width: "auto", height: "70px" }}
                        src={`${Constants.BASE_URL}${image}`}
                        alt=""
                      />
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          </FormGroup>
        )}
        <FormGroup row>
          <Col md={12} className="text-right">
            <Button
              type="submit"
              color="primary"
              className="ml-2"
              onClick={() => save()}
            >
              Crear integrante
            </Button>
          </Col>
        </FormGroup>
        <div className="members">
          <div className="row">
            {members.map((item: any) => (
              <div className="col-3 item mb-2">
                <button
                  style={{
                    position: "absolute",
                    right: "0",
                    background: "black",
                    color: "white",
                    border: "none",
                    borderRadius: "100%",
                  }}
                  onClick={() => remove(item.id)}
                >
                  X
                </button>
                <img
                  src={`${Constants.BASE_URL}${item.image}`}
                  style={{ width: "100%" }}
                  alt=""
                />
                <div className="remate-name">
                  <span>Título: {item.title}</span>
                  <br />
                  <span>URL: {item.url}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
}
